import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { useToast } from '@/components/base/ToastProvider';
import { topicRising, topicWall } from '@/mocks/home';
import { formatHeat } from '@/pages/home/utils';

const levelClass: Record<string, string> = {
  hot: 'bg-primary-500 text-background-50 hover:bg-primary-600 dark:text-foreground-950',
  warm: 'bg-accent-100 text-accent-900 hover:bg-accent-200 border border-accent-200',
  normal: 'bg-background-100 text-foreground-800 hover:bg-background-200 border border-background-200',
};

const levelText: Record<string, string> = {
  hot: 'text-[15px] font-semibold',
  warm: 'text-[14px] font-medium',
  normal: 'text-[13px]',
};

export default function TopicWall() {
  const { showToast } = useToast();

  return (
    <section id="topic" className="scroll-mt-header w-full bg-secondary-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <SectionHeading
              index="03"
              eyebrow="Topic Wall"
              title="话题墙 · 24 个高频争议标签"
              desc="所有标签都从条目关键词里汇总而来，同一标签下条目越多、讨论越集中，标签就越醒目。点开任意标签即可筛选相关条目。"
            />
            <div className="flex flex-wrap gap-2">
              {topicRising.slice(0, 3).map((topic) => (
                <span
                  key={topic.name}
                  className="flex items-center gap-1.5 rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5 text-xs font-medium text-foreground-800"
                >
                  <i className="ri-arrow-up-line flex h-3.5 w-3.5 items-center justify-center text-sm text-primary-600" />
                  {topic.name}
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-9 rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-8">
            <div className="flex flex-wrap gap-2.5 md:gap-3">
              {topicWall.map((topic) => (
                <button
                  key={topic.name}
                  type="button"
                  onClick={() => showToast(`已为你筛选「${topic.name}」相关条目，共 ${formatHeat(topic.heat)} 热度`)}
                  className={`inline-flex items-center gap-2 rounded-full px-3.5 py-2 transition-colors ${levelClass[topic.level]} ${levelText[topic.level]}`}
                >
                  <span className="opacity-60">#</span>
                  {topic.name}
                  <span className="opacity-60">{formatHeat(topic.heat)}</span>
                </button>
              ))}
            </div>

            <div className="mt-7 grid grid-cols-2 gap-4 border-t border-background-200/70 pt-6 md:grid-cols-4">
              <div>
                <p className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">4 大圈层</p>
                <p className="mt-1 text-xs text-foreground-600">娱乐 · 网红 · 科技 · 商界</p>
              </div>
              <div>
                <p className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">12h 一轮</p>
                <p className="mt-1 text-xs text-foreground-600">标签热度同步刷新</p>
              </div>
              <div>
                <p className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">96 条</p>
                <p className="mt-1 text-xs text-foreground-600">今日在库话题条目</p>
              </div>
              <div>
                <p className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">2 万+</p>
                <p className="mt-1 text-xs text-foreground-600">累计处理纠错反馈</p>
              </div>
              <div>
                <p className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">100%</p>
                <p className="mt-1 text-xs text-foreground-600">标注公开来源线索</p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}